import { AvailableScriptsComponent } from './components/pages/available-scripts/available-scripts.component';
import { DatasourcePageComponent } from './components/pages/datasource-page/datasource-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './components/pages/landing-page/landing-page.component';
import { LogoutPageComponent } from './components/pages/logout-page/logout-page.component';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { DefaultLayoutComponent } from './components/pages/default-layout/default-layout.component';
import { DashboardPageComponent } from './components/pages/dashboard-page/dashboard-page.component';
import { ViewdatasrcComponent } from './components/pages/viewdatasrc/viewdatasrc.component';
import { OutputstoragePageComponent } from './components/pages/outputstorage-page/outputstorage-page.component';
import { CodereviewPageComponent } from './components/pages/codereview-page/codereview-page.component';
import { WorkflowCompletePageComponent } from './components/pages/workflow-complete-page/workflow-complete-page.component';
import { TableviewSchemaComponent } from './components/pages/tableview-schema/tableview-schema.component';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from './guard/auth/auth.guard';
import { LoggedInGuard } from './guard/loggedInGuard/logged-in-guard.guard';


export const routes: Routes = [
  {
    path:'',
    component: LandingPageComponent, canActivate: [LoggedInGuard]
  },
  {
    path: 'loginpage',
    component: LoginPageComponent, canActivate: [LoggedInGuard]
  },
  {
    path: 'defaultlay',
    component: DefaultLayoutComponent,
  },
  {
    path: 'dashboardpage',
    component: DashboardPageComponent, canActivate: [AuthGuard]
  },
  {
    path: 'viewdatasrc',
    component: ViewdatasrcComponent, canActivate: [AuthGuard]
  },
  {
    path: 'datasrc',
    component: DatasourcePageComponent, canActivate: [AuthGuard]
  },
  {
    path: 'tabview',
    component: TableviewSchemaComponent, canActivate: [AuthGuard]
  },
  {
    path: 'scriptview',
    component: AvailableScriptsComponent, canActivate: [AuthGuard]
  },
  {
    path: 'outputstore',
    component: OutputstoragePageComponent, canActivate: [AuthGuard]
  },
  {
    path: 'codereview',
    component: CodereviewPageComponent, canActivate: [AuthGuard]
  },
  {
    path:'workflowcomp',
    component: WorkflowCompletePageComponent, canActivate: [AuthGuard]
  },
  {
    path: 'logoutpage',
    component: LogoutPageComponent, canActivate: [AuthGuard]
  },
  {
    path: '**',
    component: LoginPageComponent, canActivate: [AuthGuard]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
